// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__QN9Iv","paragraph":"styles_paragraph__ZD5Yo"};